import { tracking } from '@iwoca/frontend-tracking-library';
import { Accordion, Button, IwocaLogo } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import MandaSVG from '../../../../svgComponents/mandaSVG/index';

export function PromotionAccordion() {
    const title = (
        <div className="flex items-center gap-s">
            <span className="flex h-[48px] w-[48px] items-center justify-center overflow-hidden rounded-full bg-[#F5F8FA]">
                <IwocaLogo iconOnly className="h-[26px] w-[26px]" />
            </span>
            <span className="text-s font-med">
                <FormattedMessage
                    id="_.cross_sell_accordion.title"
                    defaultMessage="See what else iwoca can offer you"
                />
            </span>
        </div>
    );

    return (
        <Accordion
            title={title}
            className="!rounded-m !border-secondary-90"
            titleClassName="!pt-s !pl-s !pb-s !pr-0"
            variant="secondary"
            size="small"
        >
            <div className="space-y-s">
                <div className="flex flex-col gap-m rounded-m border border-secondary-90 bg-white p-l">
                    <span className="h-auto w-[48px]">
                        <MandaSVG className="w-full [&_path]:fill-black" />
                    </span>
                    <span className="text-s font-bold text-structure-20">
                        <FormattedMessage
                            id="_.cross_sell_accordion.manda_text"
                            defaultMessage="We help you sell your business or acquire others with manda, powered by iwoca."
                        />
                    </span>
                    <Button
                        href="https://www.iwoca.co.uk/manda"
                        target="_blank"
                        rel="noopener noreferrer"
                        size="small"
                        className="self-start"
                        onClick={() => tracking.ampli.mandaPromotionClicked()}
                    >
                        <FormattedMessage
                            id="_.cross_sell_accordion.manda_button"
                            defaultMessage="Learn more"
                        />
                    </Button>
                </div>
                <div className="flex flex-col gap-m rounded-m border border-secondary-90 bg-white p-l">
                    <span className="h-auto w-[48px]">
                        <IwocaLogo iwocaPay className="w-full" />
                    </span>
                    <span className="text-s font-bold text-structure-20">
                        <FormattedMessage
                            id="_.cross_sell_accordion.iwocapay_text"
                            defaultMessage="Let your trade customers spread the cost while you get paid up front everytime with iwocaPay."
                        />
                    </span>
                    <Button
                        href="https://www.iwoca.co.uk/iwocapay-seller-watch-demo?utm_source=core_biz_account_page&utm_medium=referral"
                        target="_blank"
                        rel="noopener noreferrer"
                        size="small"
                        className="self-start"
                        onClick={() =>
                            tracking.ampli.iwocaPayPromotionClicked()
                        }
                    >
                        <FormattedMessage
                            id="_.cross_sell_accordion.iwocapay_button"
                            defaultMessage="Watch a 2 min demo"
                        />
                    </Button>
                </div>
            </div>
        </Accordion>
    );
}
